import Box from "@mui/material/Box";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";

const HomeImages = [
  "https://d3lwdqji776yyc.cloudfront.net/HomeImages/srk%20in%20osbyos%20honoured%20latrobeuni%20doctrate%20in%20melbourne.webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/srk%20in%20osbyos%20%40Vogue%20Women%20Of%20The%20Year%20Awards.webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/srk%20in%20osbyos%20%40burjeel%20ad.webp",
  "https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp+Image+2025-10-20+at+21.02.29+(1).jpeg",
 "https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp+Image+2025-10-20+at+21.02.30.jpeg" ,

"https://d3lwdqji776yyc.cloudfront.net/HomeImages/virat%20in%20osbyos%20for%20his%20wedding.webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/virat%20kohli%20in%20osbyos%20%40charity%20ball%20london.webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/virat%20kohli%20in%20osbyos%20%40zaheer%20khan%20wedding%20(2).webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp%20Image%202025-06-21%20at%204.06.43%20PM.jpeg",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp%20Image%202025-06-21%20at%204.51.24%20PM.jpeg",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/vicky_katrina_1_0.jpg",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/IMG_7714+(1)-optimized.webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/RajkummarRao_26-11-24_Shot10634+(1)-optimized.webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/sos+8+(1)-optimized.webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/IMG_6186-optimized.webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/vicky%20kaushal%20in%20osbyos%20%40MansWorld%20July%202021%20Cover%20story.webp",
,"https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp%20Image%202025-06-21%20at%204.47.00%20PM%20(1).jpeg",

"https://d3lwdqji776yyc.cloudfront.net/HomeImages/486433434_1086877243478295_188267401417229628_n.jpg",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/20240806131242_0V8A1368+(1)+(1)-optimized+(1).webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/VD6255+copy+(1)+(1)-optimized+(1).webp",


,"https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp%20Image%202025-06-21%20at%204.59.42%20PM.jpeg"
,"https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp%20Image%202025-06-21%20at%205.01.16%20PM.jpeg",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp%20Image%202025-06-21%20at%205.16.50%20PM.jpeg", 
//  "https://d3lwdqji776yyc.cloudfront.net/HomeImages/aparshakti%20%20khurana%20in%20osbyos%20%40iifa2022%20(2).webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp%20Image%202025-06-21%20at%204.47.09%20PM%20(1).jpeg",
,"https://d3lwdqji776yyc.cloudfront.net/HomeImages/Armaan%20Malik%20in%20osbyos%20%40how%20many%20song%20GQ%20cover%20India.webp"
,"https://d3lwdqji776yyc.cloudfront.net/HomeImages/ayushman%20khurrana%20in%20osbyos%20%40flimfare%20awards%202021.webp"
,"https://d3lwdqji776yyc.cloudfront.net/HomeImages/dilquer%20salmaan%20in%20osbyos%20%40bbc%20top%20gear%20mag%20india%20awards.webp"
,"https://d3lwdqji776yyc.cloudfront.net/HomeImages/Ayushmann%20Khurrana%20in%20osbyos%20%40filmfare%20cover.webp"
,"https://d3lwdqji776yyc.cloudfront.net/HomeImages/srk%20%20in%20osbyos%20%40Crystal%20Award%20at%20World-Economic%20Forum%20in%20Davos%20(2).webp",
"https://d3lwdqji776yyc.cloudfront.net/HomeImages/WhatsApp-Image-2024-08-29-at-1.48.22-PM-768x960.jpeg",
,"https://d3lwdqji776yyc.cloudfront.net/HomeImages/Ayushmann%20Khurrana%20in%20osbyos%20%40abpnewstv.webp"

]

export default function MasonryImageList() {
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <ImageList variant="standard" cols={3} gap={5}>
        {HomeImages.map((item) => (
          <ImageListItem key={item}>
            <img 
              src={`${item}?w=248&fit=crop&auto=format`}
              srcSet={`${item}?w=248&fit=crop&auto=format&dpr=2 2x`}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}

